import { useContext } from "react";

import { ChatBotConfigContext } from "./ChatBotConfigContext";

export const useChatBotConfigContext = () => {
  // const context = useContext(ChatBotConfigContext);

  // if (!context)
  //   throw new Error(
  //     "useChatBotConfigContext context must be use inside ChatBotConfigProvider"
  //   );

  // return context;
  return {
    chatBotConfig: {
      id: "81007d07-8279-4eda-a8db-22445e99d573",
      color: "#d9d9d9",
      messageColor: "#7b157d",
      position: "right_panel_middle",
      chatTitle: "AI Assistant",
      messageTitle: "Hello!",
      description: "How can I help you today?",
      isDefault: true,
      isSurvey: true,
      isFAQ: true,
      isPublished: true,
      stockSymbol: "ZIG",
    },
    chatBotData: { companyId: "hello" },
    handleOpenChatBot: () => {},
    handleCloseFaqs: () => {},
    handleCloseChatBot: () => {},
  };
};
